export default __webpack_public_path__ + "static/media/3stepweightloss_2@3x.39e8865c.jpg";